import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getResults } from '../util/getResults';
import CommunityResult from './community-result';

var currentStateId;
const ResultsContainer = () => {
  const communities = useSelector((state) => state.communities);
  const regionId = useSelector((state) => state.regionData.regionId);
  const results = getResults(communities);
  
  useEffect(() => {
    //on initial component render store the current state we are looking at
    currentStateId = regionId;
  }, []);

  return (
    <>
      <ul className="results-container" id="resultsContainer" aria-label='results'>
        {!communities.isFetching && results && results.map((result, idx) => (
          <li className="result" key={idx}>
            <CommunityResult {...result} />
          </li>
        ))}
      </ul>
    </>
  );
};

export default ResultsContainer;
